import * as React from 'react'

import {ImageSkuBlock} from "@components";


export default function imageSkuColumn() {
    return {
        name: 'thumbnail', label: 'Product Image',
        options: {
			headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value) => <ImageSkuBlock imageURL={value}
            />
        }
    }
}